export const STEP_ORDER = [
  'add-documents',          // 0. Add Documents (upload to kick off synthesis)
  'review-summaries',       // 1. Document Analysis + Process Synthesis
  'approve-stakeholders',   // 2. Stakeholders & Systems (extracted during synthesis)
  'validate-process-map',   // 3. Process Map (manual trigger, uses synthesis)
  'approve-terminology',    // 4. Terminology (auto-generated from synthesis, reviewed before SOP)
  'generate-sop',           // 5. Generate SOP (uses synthesis + approved terminology)
  'fill-gaps',              // 6. Fill Gaps / Interviews (needs SOP)
  'update-change',          // 7. Update/Change (needs SOP)
];

/**
 * Steps that never gate what comes after them.
 *
 * Reviewing the summaries and the process synthesis (1a/1b) is worth doing and
 * stays in the flow, but sitting on it should not stop the user reaching
 * Approve Stakeholders. Step 2 renders its own notice when the synthesis it
 * needs is missing, which tells the user more than a locked tab does.
 *
 * approve-terminology is deliberately absent: terminology is reviewed before it
 * flows into the generated SOP, so Step 4 still gates Step 5.
 */
export const NON_BLOCKING_STEPS = [
  'add-documents',
  'review-summaries',
  'validate-process-map',
];

/** The steps that must be complete before `stepId` can unlock. */
export function blockingStepsBefore(stepId: string): string[] {
  const stepIdx = STEP_ORDER.indexOf(stepId);
  if (stepIdx < 0) return [];
  return STEP_ORDER.slice(0, stepIdx).filter((s) => !NON_BLOCKING_STEPS.includes(s));
}

/** The first blocking step the user still has to finish, or null if none. */
export function firstIncompleteBlocker(
  stepId: string,
  completedSteps: Set<string>
): string | null {
  return blockingStepsBefore(stepId).find((s) => !completedSteps.has(s)) ?? null;
}
